import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["panel", "icon", "startInput", "endInput"]

  toggleCustom(event) {
    event.preventDefault()

    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle("hidden")
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180")
    }
  }

  // "From" changed: if it moved past "To", push "To" up to match.
  startChanged() {
    if (this.bothPresent && this.startValue > this.endValue) {
      this.endInputTarget.value = this.startValue
    }
    this.submit()
  }

  // "To" changed: if it fell before "From", pull "From" down to match.
  endChanged() {
    if (this.bothPresent && this.endValue < this.startValue) {
      this.startInputTarget.value = this.endValue
    }
    this.submit()
  }

  submit() {
    if (this.hasStartInputTarget) {
      this.startInputTarget.form.submit()
    }
  }

  // Date inputs use ISO format (YYYY-MM-DD), so string comparison is safe.
  get bothPresent() {
    return this.hasStartInputTarget && this.hasEndInputTarget && this.startValue && this.endValue
  }

  get startValue() {
    return this.startInputTarget.value
  }

  get endValue() {
    return this.endInputTarget.value
  }
}
